import { PrimaryButton } from '@/common/Button';
import TrackWrapper from '@/common/TrackWrapper';
import LoadingCard, {
  CardType
} from '@/home/HeroCardsReturnUser/Cards/LoadingCard';
import useHasPIP from '@/home/hooks/useHasPIP';
import formatEvent from '@/home/utils/formatEvent';
import useGetTradeInStatus from '~/components/home/hooks/useGetTradeStatus';
import { useIsTradeLoaded } from '~/context/common/TradeContext';
import { nativeSrpPayload, nativeStcPayload } from '~/native/home/utils';
import { activeTradeStatuses, ctaMap, TradeStatus } from './constants';
import Details from './Details';
import Status from './Status';
import DefaultCardImage from '../DefaultCardImage';
import {
  CardContainer,
  Heading,
  HeadingContainer,
  TradeGridWrapper
} from '../styles';

export default function TradeCard() {
  const hasPip = useHasPIP();
  const isTradesLoaded = useIsTradeLoaded();
  const tradeStatus = useGetTradeInStatus();
  const hasTrade = tradeStatus !== TradeStatus.None;

  const heading = hasTrade ? 'Sell or trade' : 'Get a real offer for your car';
  const buttonUrl = activeTradeStatuses[tradeStatus] ? '/cars' : '/sell-my-car';
  const nativePayloadToUse = activeTradeStatuses[tradeStatus]
    ? nativeSrpPayload
    : nativeStcPayload;

  return isTradesLoaded ? (
    <TrackWrapper
      event={formatEvent('Viewed - Home feed card', {
        description: 'STC card',
        status: tradeStatus === TradeStatus.None ? 'default' : tradeStatus,
        cta: ctaMap[tradeStatus]
      })}
      trackOnce
    >
      <CardContainer className="gap-16" isDefault={!hasTrade}>
        <TradeGridWrapper defaultLayout={!hasTrade}>
          <HeadingContainer defaultLayout={!hasTrade}>
            <Heading data-qa="trade-card-heading">{heading}</Heading>
            {hasTrade && <Status tradeStatus={tradeStatus} />}
          </HeadingContainer>

          <DefaultCardImage
            defaultLayout={!hasTrade}
            url={'/images/graph-sell-or-trade.png'}
            altText="graph"
          />

          <Details />
        </TradeGridWrapper>

        <a
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            description: `STC card`,
            status: tradeStatus === TradeStatus.None ? 'default' : tradeStatus,
            cta: ctaMap[tradeStatus]
          })}
          href={buttonUrl}
          data-qa={'trade-card-cta'}
          className={hasPip ? 'hidden' : ''}
          data-native-payload={nativePayloadToUse}
        >
          <PrimaryButton className="h-40 min-h-[40px] w-full">
            {ctaMap[tradeStatus]}
          </PrimaryButton>
        </a>
      </CardContainer>
    </TrackWrapper>
  ) : (
    <LoadingCard card={CardType.Trade} />
  );
}
